import ApiService from "@/services/api.service";

export async function changeSaleStatus(propertyId, sellerId, status) {
    return await ApiService.get("property/" + propertyId + "/seller/" + sellerId + "/status/" + status);
}